import { VERDICTS } from '../copy';
import { compactMoney } from '../format';
import { readinessScore } from './ReadinessBody';
import { COVERAGE } from './FinancingScenarioBody';

const clamp = (pct) => Math.max(4, Math.min(100, pct));

// What a result says at a glance, for its tile: the key figure, a short
// caption and, where the card has one, its pill or meter. Figures are the
// saved result's own; nothing is worked out here beyond formatting.
//   { value, caption, pill: { label, color, ink, tint }, meter: { pct, className } }
const GLANCES = {
  am_i_ok: (d) => {
    const gap = d.gap || 0;
    return {
      value: `${compactMoney(Math.abs(gap))} ${gap < 0 ? 'to spare' : 'short'}`,
      caption: d.goal ? `of your ${compactMoney(d.goal)} goal` : null,
      pill: VERDICTS[d.verdict] || null,
      meter: d.coverage_pct ? { pct: clamp(d.coverage_pct), className: 'bg-succeedo-orange' } : null,
    };
  },
  valuation_range: (d) => ({
    value: compactMoney(d.value),
    caption: d.low && d.high ? `${compactMoney(d.low)}–${compactMoney(d.high)}` : null,
  }),
  readiness_scorecard: (d) => {
    const score = readinessScore(d);
    const tier = String(d.tier || '').replace(/_/g, ' ');
    return {
      value: `${score} / 100`,
      caption: tier ? tier.charAt(0).toUpperCase() + tier.slice(1) : null,
      meter: { pct: clamp(score), className: 'bg-succeedo-orange' },
    };
  },
  value_gap: (d) => ({
    value: `+${compactMoney(d.value_gap)}`,
    caption: d.current_value && d.potential_value
      ? `${compactMoney(d.current_value)} → ${compactMoney(d.potential_value)}`
      : null,
    meter: d.current_value && d.potential_value
      ? { pct: clamp((d.current_value / d.potential_value) * 100), className: 'bg-[hsl(var(--chart-2))]' }
      : null,
  }),
  wealth_goal: (d) => ({
    value: compactMoney(d.goal),
    caption: d.years_to_exit ? `to step away in ${d.years_to_exit} years` : 'to step away',
  }),
  financing_scenario: (d) => ({
    value: `${compactMoney(d.monthly_payment)} a month`,
    caption: COVERAGE[d.coverage]?.label || null,
  }),
  deal_structure: (d) => ({
    value: compactMoney(d.after_tax_proceeds),
    caption: d.cash_at_closing ? `you keep · ${compactMoney(d.cash_at_closing)} at closing` : 'you keep',
  }),
};

export default function glance(artifact) {
  const build = GLANCES[artifact.kind];
  return build ? build(artifact.data || {}) : { value: null, caption: artifact.summary };
}
